import { render, staticRenderFns } from "./BookingInRoom.vue?vue&type=template&id=3b911963&scoped=true&"
import script from "./BookingInRoom.vue?vue&type=script&lang=js&"
export * from "./BookingInRoom.vue?vue&type=script&lang=js&"
import style0 from "./BookingInRoom.vue?vue&type=style&index=0&id=3b911963&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b911963",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VDivider,VIcon,VMenu})
